import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { isGeneralFormVisible } from "./generalFormsCatalog";

/**
 * Blocks hidden catalog forms from opening while keeping their routes registered.
 * Flip `visible` on the catalog entry to restore access.
 */
const RequireVisibleGeneralForm = ({ formId, children }) => {
  if (!isGeneralFormVisible(formId)) {
    return <Navigate to="/general-forms" replace />;
  }
  return children;
};

RequireVisibleGeneralForm.propTypes = {
  formId: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default RequireVisibleGeneralForm;
